import { Breakpoints } from "../../breakpoints.js";

window.initGridCarousels = (context = document) => {
  const itemClass = 'grid-carousel';
  context.querySelectorAll(`.${itemClass}`).forEach((carouselItem) => {

      const swiper = carouselItem.querySelector('swiper-container');
      if (!!swiper.initialized) return;

      const maxSlides = Number(swiper.dataset.slidesPerView);

      const swiperParams = {
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 24,
          },
          [Breakpoints.sm]: {
            slidesPerView: 2.5,
            spaceBetween: 24,
          },
          [Breakpoints.md]: {
            slidesPerView: 3.5,
            spaceBetween: 24,
          },
          [Breakpoints.xl]: {
            slidesPerView: maxSlides,
          },
        },
        navigation: {
          clickable: true,
          // disabledClass: "opacity-30 pointer-events-none",
          disabledClass: "disabled",
          nextEl: carouselItem.querySelector(`.next`),
          prevEl: carouselItem.querySelector(`.prev`),
        },
        // Hack: Inject styles into swiper.
        injectStyles: [`:host .swiper { overflow: visible !important; }`],
      };

      Object.assign(swiper, swiperParams);

      swiper.initialize();

      window.gridCarousels.push(swiper);
  });
};

if (!window.gridCarousels || !window.gridCarousels.length) { // Only run once
  window.gridCarousels = [];
  document.addEventListener("DOMContentLoaded", () => {
    window.initGridCarousels();
  });
}
